import React, { FC } from 'react';
import { Box, LottiePlayerECOMMBX, makeStyles, Typography } from '@dxb-web-ui-framework/design-system';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  lottiePlayerContainer: {
    minWidth: 500,
    [breakpoints.down('md')]: {
      '& div:first-child': {
        transform: 'translate(0px, 70px)',
      },
    },
  },
  termsPageContainer: {
    [breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  termsPageItem: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '50%',
    [breakpoints.down('md')]: {
      maxWidth: '80%',
    },
  },
}));
const TermsConditionSplitScreen: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Box display={'flex'} alignItems={'center'} className={classes.termsPageContainer}>
      <Box className={classes.termsPageItem}>
        <Typography variant={'h2'} component={'h2'} color={'primary'}>
          {t('brandedAppConfig.termsCondition.Text1')}

          <Typography variant={'h3'} component='span' color={'secondary'}>
            {' '}
            {t('brandedAppConfig.termsCondition.Text2')}
          </Typography>
        </Typography>
      </Box>

      <Box className={classes.termsPageItem}>
        <Box className={classes.lottiePlayerContainer} display={'flex'}>
          <LottiePlayerECOMMBX height={416} icon='ecommbx_lock' loop play width={500} />
        </Box>
      </Box>
    </Box>
  );
};

export { TermsConditionSplitScreen };
